module.exports = __webpack_public_path__ + "assets/icons/yard-debris-active.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/yard-debris-active.png
// module id = ./src/styles/icons/jobcategories/yard-debris-active.png
// module chunks = 0